exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-download[data-v-ef2e81f0]{width:250px;margin-right:50px}.mx-auto[data-v-ef2e81f0]{width:70%;margin:0 auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ef2e81f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/meetingvideoviewer/MeetingVideoViewer.vue
// module id = 1748
// module chunks = 0